import { render, staticRenderFns } from "./PendingEvents.vue?vue&type=template&id=1151960a&scoped=true"
import script from "./PendingEvents.vue?vue&type=script&lang=js"
export * from "./PendingEvents.vue?vue&type=script&lang=js"
import style0 from "./PendingEvents.vue?vue&type=style&index=0&id=1151960a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151960a",
  null
  
)

export default component.exports